import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import AppNavbar from "../../components/home/Navbar";
import Footer from "../../components/footer/Footer";
import Seo from "../../components/seo/Seo";
import { guideArticles } from "../../content/guide/articles";
import "../styles/guide.css";
import { PAGES } from "../../content/pages";

function GuideIndex() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Seo {...PAGES.guide} />
      <AppNavbar />

      <main className="guide">
        <header className="guide-header">
          <p className="guide-eyebrow">Guide de l'entrepreneur</p>
          <h1 className="guide-title">
            Entreprendre au <span>Cameroun</span>
          </h1>
          <p className="guide-lead">
            Des réponses claires pour créer, organiser et protéger votre
            entreprise.
          </p>
        </header>

        <ul className="guide-list">
          {guideArticles.map((article) => (
            <li key={article.slug}>
              <Link to={`/guide/${article.slug}`} className="guide-card">
                <h2 className="guide-card-title">{article.title}</h2>
                <p className="guide-card-summary">{article.summary}</p>
                <span className="guide-card-more">
                  Lire l'article <FiArrowRight aria-hidden="true" />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </main>

      <Footer />
    </>
  );
}

export default GuideIndex;
